interface StaticReviewSelectionSummaryProps {
	selectedCount: number;
	maxReviews?: number;
	onClick: () => void;
	disabled?: boolean;
}

export default function StaticReviewSelectionSummary({ selectedCount, maxReviews, onClick, disabled = false }: StaticReviewSelectionSummaryProps) {
	const visibleCount = maxReviews != null ? Math.min(selectedCount, maxReviews) : selectedCount;

	return (
		<button
			type="button"
			onClick={onClick}
			disabled={disabled}
			className={`w-full p-4 rounded-xl border border-gray-200 text-left transition-all ${disabled ? "opacity-50 cursor-not-allowed" : "hover:border-gray-300 hover:bg-gray-50 cursor-pointer"}`}
		>
			{/* Counts row */}
			<div className="flex items-center gap-2 mb-2">
				<span className="text-sm font-medium text-gray-900">
					{selectedCount} review{selectedCount !== 1 ? "s" : ""} selected
					<span className="text-tertiary font-normal"> · {visibleCount} visible</span>
				</span>
			</div>

			{/* Helper text and action row */}
			<div className="flex items-center justify-between">
				<span className="text-sm text-tertiary truncate pr-2">Only selected reviews will be displayed</span>
				<span className="text-sm font-medium text-gray-600 flex items-center gap-1 shrink-0">
					Select
					<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
						<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
					</svg>
				</span>
			</div>
		</button>
	);
}
